import { ID } from '..';
import { MultiSelectClickableCollectionOptions } from '../../interfaces/options';

export const DefaultMultiSelectClickableCollectionOptions: MultiSelectClickableCollectionOptions<
	any
> = {
	items: null,
	idField: ID.ID,
	id: '',
	callBack: null,
	template: undefined
};
